/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * VisitDeletedDtoBase
 * auto generated base class for the model VisitDeletedDtoModel.
 */
export const VisitDeletedDtoModelBase = ModelBase
  .named('VisitDeletedDto')
  .props({
    __typename: types.optional(types.literal("VisitDeletedDto"), "VisitDeletedDto"),
    id: types.identifier,
    name: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class VisitDeletedDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get name() { return this.__attr(`name`) }
}
export function selectFromVisitDeletedDto() {
  return new VisitDeletedDtoModelSelector()
}

export const visitDeletedDtoModelPrimitives = selectFromVisitDeletedDto().name
